export const API_BASE_URL = 'http://localhost:8000/api/v1'

const token = localStorage.getItem("token")


export const config = {
    headers: {
        'Authorization':`Bearer ${token}`,
        'Content-Type':"application/json"
    }
}
